<template>
  <div class="wrapper">
    <h1>{{ habit.name }}</h1>
    <div class="habit-card__tabs">
      <div class="habit-card__tabs--header">
        <div
          class="tab-header-item"
          @click="selectedTab = tab.key"
          v-for="(tab, key) in tabs"
          :key="key"
          :style="`background: ${selectedTab === tab.key ? '#3a4276' : 'transparent'}`"
        >{{ tab.name }}</div>
      </div>
        <div style="overflow-y: auto; height: 60vh; font-size: 0.8rem;"
          v-if="selectedTab === 'logs'">
          <div style="margin: 25px 0; display: flex;" v-for="(log, key) in logList" :key="key">
            <p @click="logTheLog(log)">
              created: {{ $moment(log.created).format('DD-MM-YYYY, HH:mm') }}
               log for day: {{ $moment(log.date).format('DD-MM-YYYY') }},
            </p>
           <font-awesome-icon style="margin: 0 5px; font-width: 1rem;"
            @click="removeLogById(log)" color="red" icon="trash" />
          </div>
        </div>
        <div style="height: 60vh; width: 100%;" v-if="selectedTab === 'calendar'">
          <Calendar :activityLogs="habit.logs" :habit="habit"/>
          <slot />
        </div>
<!-- <div v-if="selectedTab === 'tips'" style="overflow-y: auto; height: 50vh;">coś</div> -->
    </div>
    <b-button style="position: fixed; bottom: 30px; width: 90vw;"
      @click="closeEvent" type="is-primary" expanded>close</b-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Calendar from './Calendar.vue';

export default {
  components: {
    Calendar,
  },
  props: {
    habit: {
      type: Object,
      require: true,
    },
    closeEvent: {
      type: Function,
    },
  },
  computed: {
    logList() {
      return [...this.habit.logs].reverse();
    },
  },
  data() {
    return {
      selectedTab: 'calendar',
      tabs: [
        {
          name: 'calendar',
          key: 'calendar',
        },
        {
          name: 'logs',
          key: 'logs',
        },
        // {
        //   name: 'tips',
        //   key: 'tips',
        // },
      ],
    };
  },
  methods: {
    ...mapActions({
      removeLogById: 'habitsDashboard/removeLogById',
    }),
    logTheLog(log) {
      console.log(log);
    },
  },
  mounted() {
    console.log(this.habit);
  },
};
</script>

<style lang='scss' scoped>
h1 {
  font-size: 1.4rem;
  font-weight: 700;
  padding: 30px 0;
}
.wrapper {
  overflow-x:auto;
  padding: 40px 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100vw;
  height: 100vh;
  background: #1B263B;
}
.habit-card {
    &__tabs {
      position: relative;
      &--header {
        display: flex;
        align-items: center;
        .tab-header-item {
          margin: 5px 10px;
          border: 1px solid #ffffff63;
          border-radius: 5px;
          padding: 8px 12px;
        }
      }
    }
  }
</style>
